module.exports = __webpack_public_path__ + "img/in-treatment.923f5f9c.svg";